export default function Translations(string) {
  const language = require('./languages/en.json');
  if (!language[string]) {
    console.warn('Error on string: ', string);
  }
  return language[string];
};
